import { AccountStatus } from './account-status.model';
import { CustomerTag } from './customer-tag.model';
import { ClientType } from './client-type.model';
import { LoginType } from '../../models/login-response.model';

export class UserContext {
  portalId: string;
  memberId: string;
  // User ACN (Account Number)
  externalRef: string;
  populationId: string;
  populationName: string | undefined;
  clubId: number;
  sessionId: string;
  lcid: string;
  status: AccountStatus;
  customerTags: CustomerTag[];
  clientType: ClientType;
  loginType: LoginType;
  clubs?: number[];
  clientAttribute: string;
  tierId: number;
  tierName: string;
  isCheckedIn: boolean;
}
